import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'baseline',
      justifyContent: 'space-between',
    },
    label: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: theme.typography.pxToRem(16),
    },
    select: {
      width: 132,
    },
    menuPaper: {
      marginTop: theme.spacing(-1),
    },
  }),
  { name: 'FieldCases' }
);
